import { DEFAULT_PORTAL_MODE, getPortalTokens } from './portalTheme';

export const PORTAL_COLOR_MODE_STORAGE_KEY = 'sure-space-portal-color-mode';
export const PORTAL_COLOR_MODE_RESET_EVENT = 'portal-color-mode-reset';

const isPortalColorMode = (value) => value === 'light' || value === 'dark';

export function readStoredPortalColorMode() {
  try {
    const stored = window.localStorage.getItem(PORTAL_COLOR_MODE_STORAGE_KEY);
    return isPortalColorMode(stored) ? stored : DEFAULT_PORTAL_MODE;
  } catch {
    return DEFAULT_PORTAL_MODE;
  }
}

export function persistPortalColorMode(mode) {
  const next = isPortalColorMode(mode) ? mode : DEFAULT_PORTAL_MODE;
  try {
    window.localStorage.setItem(PORTAL_COLOR_MODE_STORAGE_KEY, next);
  } catch {
    // Ignore quota / private-mode failures.
  }
  return next;
}

export function applyPortalColorMode(mode) {
  const next = isPortalColorMode(mode) ? mode : DEFAULT_PORTAL_MODE;
  const tokens = getPortalTokens(next);
  const root = document.documentElement;

  root.dataset.portalMode = next;
  root.style.setProperty('--portal-accent', tokens.accent);
  root.style.setProperty('--portal-accent-hover', tokens.accentHover);
  root.style.setProperty('--portal-page-bg', tokens.pageBg);
  root.style.setProperty('--portal-surface', tokens.surface);
  root.style.setProperty('--portal-text', tokens.text);
}

export function resetPortalColorMode() {
  persistPortalColorMode(DEFAULT_PORTAL_MODE);
  applyPortalColorMode(DEFAULT_PORTAL_MODE);
  window.dispatchEvent(new Event(PORTAL_COLOR_MODE_RESET_EVENT));
}
